export default __webpack_public_path__ + "static/media/4079577_development_ladder_person_personal_steps_icon.c064040e.svg";